import PaginationContainer from "../../../Component/BonusUi/Pagination/Pagination"

const Pagination = () => {
  return (
    <div className='page-body'>
      <PaginationContainer />
    </div>
  )
}

export default Pagination